<townip-modal
	zIndex="1000000"
	class="tosModal"
	size="lg"
	heading="Terms of Use"
	[showCloseButton]="false">
  <townip-modal-body>
    @for (term of systemTerms; track term) {
      <townip-panel-t2
        *ngIf="!term.offlineAgreementFile && !term.acknowledge && !term.bypass"
        class="mt-3"
        heading="{{term.scope | titlecase}} Terms of Use">
        <townip-standard-alert class="mt-4" type="info" mode="lite">
          Please agree to our new <span class="font-weight-bold">{{term.scope | titlecase}} Terms of Use</span>
          updated on {{term.termsOfUseReleaseDate | standardDate}} to continue.
        </townip-standard-alert>
        <div class="mt-3">
          <p-scrollPanel [style]="{width: '100%', height: '350px', 'border-radius': '4px'}">
            <div class="padding-20">
              <townip-terms-of-use-content [tosId]="term?.termsOfUseId"></townip-terms-of-use-content>
            </div>
          </p-scrollPanel>

          <div class="mt-3">
            <div class="d-flex full-width">
              <p-checkbox [(ngModel)]="accepted" name="{{'accept' | uniqueId}}" [value]="term.scope" required></p-checkbox>
              <div *ngIf="term?.type === 'COMPANY_FORECASTER'; else mainSystem" class="margin-left-5 font-weight-bold">
                I accept the Chief IP Terms of Use and
                <a href="https://chiefip.com/privacy-policy/ " target="_blank">Privacy Policy</a>
              </div>
              <ng-template #mainSystem>
                <div class="margin-left-5 font-weight-bold">
                  I accept the Sun IP
                  @if (term.scope === termScope.Platform) {
                    Platform Terms of Use and
                    <a href="https://sunip.com/cookies-and-privacy-policy/" target="_blank">Privacy Policy</a>
                  } @else {
                    Business Terms of Use
                  }
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </townip-panel-t2>
    }
  </townip-modal-body>
  <townip-modal-footer>
    <button class="btn btn-secondary" (click)="decline()">
      <i class="fa fa-close mr-2"></i>Cancel
    </button>
    <button
      class="btn btn-primary"
      *ngIf="accepted?.length === (systemTerms | quickFilter: {acknowledge: false, bypass: false})?.length"
      (click)="accept()">
      <i class="fa fa-check mr-2"></i>Accept
    </button>
  </townip-modal-footer>
</townip-modal>
